import type discountsEn from "./discounts.en";

const discountsAr: Record<keyof typeof discountsEn, string> = {
  "disc.title": "الخصومات",
  "disc.create": "إنشاء خصم",
  "disc.select_type": "اختر نوع الخصم",
  "disc.empty_title": "أدر الخصومات والعروض",
  "disc.empty_body": "أنشئ أكواد خصم وخصومات تلقائية تُطبَّق عند الدفع، ويمكنك الجمع بينها.",
  "disc.search": "ابحث بالعنوان أو الكود",
  "disc.none_match": "لا توجد خصومات تطابق هذه الفلاتر.",
  "disc.filter.method": "الطريقة",
  "disc.filter.type": "النوع",
  "disc.col.title": "العنوان",
  "disc.col.status": "الحالة",
  "disc.col.method": "الطريقة",
  "disc.col.type": "النوع",
  "disc.col.combinations": "الجمع",
  "disc.col.used": "مرات الاستخدام",
  "disc.more_codes": "+{n} أكواد",
  "disc.status.active": "نشط",
  "disc.status.scheduled": "مجدول",
  "disc.status.expired": "منتهي",
  "disc.method.code": "كود",
  "disc.method.automatic": "تلقائي",
  "disc.method_long.code": "كود خصم",
  "disc.method_long.automatic": "خصم تلقائي",
  "disc.type.product": "مبلغ من المنتجات",
  "disc.type.order": "مبلغ من الطلب",
  "disc.type.bxgy": "اشترِ X واحصل على Y",
  "disc.type.shipping": "شحن مجاني",
  "disc.type_hint.product": "خصم على منتجات أو مجموعات محددة.",
  "disc.type_hint.order": "خصم على إجمالي الطلب.",
  "disc.type_hint.bxgy": "خصم على منتجات بناءً على مشتريات العميل.",
  "disc.type_hint.shipping": "قدّم شحنًا مجانيًا للطلب.",
  "disc.method": "الطريقة",
  "disc.code": "كود الخصم",
  "disc.code_hint": "يجب على العملاء إدخال هذا الكود عند الدفع.",
  "disc.generate": "توليد",
  "disc.title_field": "العنوان",
  "disc.title_hint": "يظهر للعملاء في السلة وعند الدفع.",
  "disc.n_codes": "{n} كود",
  "disc.manage_codes": "إدارة الأكواد",
  "disc.add_more_codes": "أضف أكوادًا أخرى أو ولّدها بالجملة",
  "disc.value": "قيمة الخصم",
  "disc.percentage": "نسبة مئوية",
  "disc.fixed": "مبلغ ثابت",
  "disc.free": "مجاني",
  "disc.applies_to": "ينطبق على",
  "disc.items.all": "كل المنتجات",
  "disc.items.collections": "مجموعات محددة",
  "disc.items.products": "منتجات محددة",
  "disc.once_per_order": "تطبيق الخصم مرة واحدة فقط لكل طلب",
  "disc.exclude_sale": "استثناء المنتجات المخفّضة مسبقًا",
  "disc.buys": "يشتري العميل",
  "disc.buy_quantity": "حد أدنى لعدد القطع",
  "disc.buy_amount": "حد أدنى لمبلغ الشراء",
  "disc.quantity": "الكمية",
  "disc.amount": "المبلغ",
  "disc.any_items_from": "أي منتجات من",
  "disc.gets": "يحصل العميل على",
  "disc.gets_hint": "يجب على العملاء إضافة الكمية المحددة أدناه إلى السلة.",
  "disc.at_value": "بقيمة مخفّضة",
  "disc.max_uses_per_order": "تحديد حد أقصى لعدد مرات الاستخدام في الطلب",
  "disc.countries": "الدول",
  "disc.all_countries": "كل الدول",
  "disc.selected_countries": "دول محددة",
  "disc.exclude_rates": "استثناء أسعار الشحن التي تتجاوز مبلغًا معينًا",
  "disc.minimum": "الحد الأدنى للشراء",
  "disc.min.none": "بدون حد أدنى",
  "disc.min.amount": "حد أدنى لمبلغ الشراء",
  "disc.min.quantity": "حد أدنى لعدد القطع",
  "disc.min.applies_selected": "ينطبق فقط على المنتجات أو المجموعات المحددة.",
  "disc.eligibility": "أهلية العملاء",
  "disc.elig.all": "كل العملاء",
  "disc.elig.segments": "شرائح عملاء محددة",
  "disc.elig.customers": "عملاء محددون",
  "disc.limits": "الحد الأقصى للاستخدام",
  "disc.limit_total": "تحديد عدد مرات استخدام هذا الخصم إجمالًا",
  "disc.limit_once": "استخدام واحد لكل عميل",
  "disc.combinations": "الجمع مع خصومات أخرى",
  "disc.combinations_hint": "يمكن الجمع بين هذا الخصم و:",
  "disc.combine.product": "خصومات المنتجات",
  "disc.combine.order": "خصومات الطلب",
  "disc.combine.shipping": "خصومات الشحن",
  "disc.dates": "فترة التفعيل",
  "disc.start_date": "تاريخ البدء",
  "disc.start_time": "وقت البدء ({tz})",
  "disc.set_end": "تحديد تاريخ انتهاء",
  "disc.end_date": "تاريخ الانتهاء",
  "disc.end_time": "وقت الانتهاء ({tz})",
  "disc.summary": "الملخص",
  "disc.no_code": "لا يوجد كود بعد",
  "disc.no_title": "لا يوجد عنوان بعد",
  "disc.performance": "الأداء",
  "disc.used": "استُخدم {n} مرة",
  "disc.duplicate": "نسخ",
  "disc.activate": "تفعيل",
  "disc.deactivate": "إيقاف",
  "disc.activated": "فُعّل الخصم.",
  "disc.deactivated": "أُوقف الخصم.",
  "disc.delete": "حذف الخصم",
  "disc.delete_title": "حذف هذا الخصم؟",
  "disc.delete_body": "لن يتمكن العملاء من استخدامه. لا يمكن التراجع.",
  "disc.codes": "أكواد الخصم",
  "disc.search_codes": "ابحث في الأكواد",
  "disc.add_codes": "إضافة أكواد",
  "disc.generate_codes": "توليد أكواد",
  "disc.add_codes_hint": "كود واحد في كل سطر (أو مفصولة بفواصل).",
  "disc.export_codes": "تصدير الأكواد",
  "disc.codes_added": "أُضيف {n} كود.",
  "disc.copy": "نسخ الكود",
  "disc.copied": "نُسخ.",
  "disc.generate_hint": "أنشئ حتى 100,000 كود فريد بنفس إعدادات هذا الخصم.",
  "disc.gen_count": "عدد الأكواد",
  "disc.gen_prefix": "بادئة",
  "disc.gen_length": "طول الكود",
  "disc.gen_example": "مثال",
  "dsum.all_products": "كل المنتجات",
  "dsum.n_products": "{n} منتجات",
  "dsum.n_collections": "{n} مجموعات",
  "dsum.off": "خصم {amount} على {what}",
  "dsum.off_each": "خصم {amount} على كل قطعة من {what}",
  "dsum.once_per_order": "يُطبَّق مرة واحدة لكل طلب",
  "dsum.off_order": "خصم {amount} على الطلب بالكامل",
  "dsum.buy": "اشترِ {n} قطع",
  "dsum.spend": "أنفق {amount}",
  "dsum.get_free": "واحصل على {n} قطع مجانًا",
  "dsum.get_off": "واحصل على {n} قطع بخصم {pct}٪",
  "dsum.max_per_order": "حد أقصى {n} مرات لكل طلب",
  "dsum.free_shipping_all": "شحن مجاني لكل الدول",
  "dsum.free_shipping_some": "شحن مجاني لـ {n} دول",
  "dsum.rates_under": "ينطبق على أسعار الشحن حتى {amount}",
  "dsum.min_amount": "حد أدنى للشراء {amount}",
  "dsum.min_quantity": "حد أدنى {n} قطع",
  "dsum.no_min": "بدون حد أدنى للشراء",
  "dsum.all_customers": "لكل العملاء",
  "dsum.n_segments": "لـ {n} شرائح عملاء",
  "dsum.n_customers": "لـ {n} عملاء",
  "dsum.limit": "حد {n} استخدامات",
  "dsum.once_per_customer": "استخدام واحد لكل عميل",
  "dsum.combines": "يُجمع مع {with}",
  "dsum.no_combine": "لا يُجمع مع خصومات أخرى",
  "dsum.class.product": "خصومات المنتجات",
  "dsum.class.order": "خصومات الطلب",
  "dsum.class.shipping": "خصومات الشحن",
  "dsum.active_from": "نشط من {from}",
  "dsum.active_until": "نشط من {from} حتى {to}",
  "picker.browse": "تصفح",
  "picker.done": "إضافة ({n})",
  "picker.none": "لا توجد نتائج.",
  "picker.title.product": "إضافة منتجات",
  "picker.title.collection": "إضافة مجموعات",
  "picker.title.segment": "إضافة شرائح عملاء",
  "picker.title.customer": "إضافة عملاء",
  "picker.search_products": "ابحث عن منتجات",
  "picker.search_collections": "ابحث عن مجموعات",
  "picker.search_segments": "ابحث عن شرائح",
  "picker.search_customers": "ابحث عن عملاء",
};

export default discountsAr;
